import { Controller } from '@hotwired/stimulus';

// Ignição não tem limiar: é ligada ou desligada. Troca o campo numérico por um
// select de estado e fixa a comparação em "igual a", já que "ignição acima de
// 0,5" não é uma frase que alguém queira escrever.
export default class extends Controller {
  static targets = ['field', 'comparison', 'comparisonWrapper', 'numeric', 'numericWrapper', 'boolean', 'booleanWrapper']

  connect() {
    this.refresh();
  }

  refresh() {
    const isIgnition = this.fieldTarget.value === 'ignition';

    this.numericWrapperTarget.classList.toggle('hidden', isIgnition);
    this.booleanWrapperTarget.classList.toggle('hidden', !isIgnition);
    this.comparisonWrapperTarget.classList.toggle('hidden', isIgnition);

    // Só o campo visível é submetido — os dois escrevem em threshold_value.
    this.numericTarget.disabled = isIgnition;
    this.booleanTarget.disabled = !isIgnition;

    if (isIgnition) this.comparisonTarget.value = 'equal';
  }
}
